import EtherIcon from '../assets/icons/Ethereum.svg';
import BnbIcon from '../assets/icons/BinanceCoin.svg';
import UsdtIcon from '../assets/icons/Tether.svg';
import BtcIcon from '../assets/icons/Bitcoin.svg';
import SolIcon from '../assets/icons/Solana.svg';
import AvaxIcon from '../assets/icons/Avalanche.svg';
import TypeIcon from '../assets/icons/type1.svg';

export function chainIcon(key) {
    if (key === 'bnb') return BnbIcon;
    if (key === 'usdt') return UsdtIcon;
    if (key === 'btc') return BtcIcon;
    if (key === 'sol') return SolIcon;
    if (key === 'avax') return AvaxIcon;
    return EtherIcon;
}

export function tokenIcon(key) {
    return chainIcon(key);
}

export function avatarIcon(key) {
    if (key === 'avatar1') return '/avatars/avatar1.png';
    if (key === 'avatar3') return '/avatars/avatar3.png';
    return '/avatars/avatar2.svg';
}

export function typeIcon() {
    return TypeIcon;
}

export function mapWillForUi(will) {
    return {
        id: will.id,
        date: {
            icon: chainIcon(will.chain_key),
            symbol: formatDate(will.date),
            chain: will.chain,
        },
        type: {
            icon: typeIcon(),
            value: will.type,
        },
        timeEnd: formatDate(will.time_end, true),
        totalValue: will.total_value,
        address: {
            icon: avatarIcon(will.address?.avatar),
            address: will.address?.address,
        },
        transaction: will.transaction,
        status: will.status,
        available_at: will.available_at,
        note: will.note,
        raw: will,
    };
}

export function mapAssetForUi(asset) {
    return {
        ...asset,
        token: {
            ...asset.token,
            icon: tokenIcon(asset.token.token_key),
        },
    };
}

function formatDate(value, short = false) {
    if (!value) return '';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    if (short) {
        return d.toLocaleDateString('en-GB');
    }
    return d.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
}
